<nav class="subnav">
  <h2>{{ resource?.title | uppercase | translate }}</h2>
</nav>
<div class="fh pb-10 content-container">
  <div class="relative">
    <app-loading-spinner *ngIf="isLoading" [inline]="1"></app-loading-spinner>
    <div>
      <img
        *ngIf="resource?.image_filename"
        src="{{ resource.image_filename | getThumbnail : 'wide' }}"
        alt="Placeholder image"
        class="rounded-lg img-fluid fade-in d-none d-sm-block mb-4"
      />

      <img
        *ngIf="resource?.image_filename"
        src="{{ resource.image_filename | getThumbnail : 'medium-landscape' }}"
        alt="Placeholder image"
        class="rounded-lg img-fluid fade-in d-block d-sm-none mb-4"
      />

      <div class="card bg-light">
        <div class="card-body">
          <div>
            
            <ul
              class="link-list"
            >
              <ng-container *ngFor="let page of pages; let index = index"
                >
                <li>
                  <a [routerLink]="[routeBase, page.content_page_id]">
                    <span class="circle-num">{{index+1}}</span>
                    <span class="icon-wrap more-link text-dark"
                      ><fa-icon [icon]="['fas', 'play-circle']"></fa-icon
                    ></span>
                    <span class="link-label"
                      >{{ page.title }}</span
                    >
                    <span class="icon-wrap more-link duo-primary-dark"
                      ><fa-icon [icon]="['fad', 'circle-chevron-right']"></fa-icon
                    ></span>
                  </a>
                </li>


                
                <!--li>
                  <a
                    class="task"
                    [routerLink]="['/' + area, 'guide', page.content_page_id]"
                  >
                    <span class="num">
                      <span class="icon-wrap">
                        <fa-icon
                          *ngIf="!page.icon"
                          [icon]="['fas', 'align-left']"
                          [fixedWidth]="true"
                        ></fa-icon>
                        <fa-icon
                          *ngIf="page.icon"
                          [icon]="['far', page.icon]"
                          [fixedWidth]="true"
                        ></fa-icon>
                      </span>
                    </span>
                    <span class="title">{{ page.title }}</span>
                    <span class="status">
                      <span class="icon-wrap text-secondary-accent">
                        <fa-icon [icon]="['fas', 'arrow-alt-right']"></fa-icon>
                      </span>
                    </span>
                  </a>
                </li-->
              </ng-container>
            </ul>
            
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
